export const replaceIdURL = (endpoint, text = "", change = "") => {
	const url = endpoint.replace(`:${text}`, change);
	return url;
};
